const baseURL = "report/export";

export const ReportEndpoint = {
  reportHistory: "report/history",
  downloadFromHistory: "report/history/export",
  studentWiseRoyalty: `${baseURL}/studentWiseRoyalty`,
  studentRedeemHistory: `${baseURL}/studentRedeemHistory`,
  studentLeadDetailed: `${baseURL}/studentLeadDetailed`,
  studentHistory: `${baseURL}/studentHistory`,
  studentDiscontinue: `${baseURL}/studentDiscontinue`,
  studentComplete: `${baseURL}/studentComplete`,
  studentAdmission: `${baseURL}/studentAdmission`,
  studentAdmissionChannal: `${baseURL}/studentAdmissionChannel`,
  stockSoldAndStockOrderedForRegistrationKit: `${baseURL}/stockSoldAndStockOrderedForRegistrationKit`,
  stockSoldAndStockOrdered: `${baseURL}/stockSoldAndStockOrdered `,
  stockSoldAndStockOrderedForHigherLevel: `${baseURL}/stockSoldAndStockOrderedForHigherLevel`,
  sipBrandPromise: `${baseURL}/sipBrandPromise`,
  purchaseReturn: `${baseURL}/purchaseReturn`,
  prodigyMetricData: `${baseURL}/prodigyMetricData`,
  poReport: `${baseURL}/poReport`,
  feedback: `${baseURL}/feedback`,
  netActiveStudent: `${baseURL}/netActiveStudent`,
  netActiveStudentChannel: `${baseURL}/netActiveStudentChannel`,
  newFranchiseeGrowthReport: `${baseURL}/newFranchiseeGrowthReport`,
  monthWiseRoyalty: `${baseURL}/monthWiseRoyalty`,
  kitSaleIndex: `${baseURL}/kitSaleIndex`,
  kitMovementReport: `${baseURL}/kitMovementReport`,
  STReport: `${baseURL}/stockreport`,
  franchiseeDetails: `${baseURL}/franchiseeDetails`,
  franchiseeAttendanceTracker: `${baseURL}/franchiseeAttendanceTracker`,
  rejoineeTrackerTrend: `${baseURL}/rejoineeAndDiscontinueTrackerTrendReport`,
  competitionParticipantStudentNational: `${baseURL}/competitionParticipantStudentNational`,
  ciWiseDropoutCount: `${baseURL}/ciWiseDropoutCount`,
  userLoginDetails: `${baseURL}/userLoginDetails`,
  franchiseeWiseDropoutReport: `${baseURL}/franchiseeWiseDropoutCount`,
  certificateReportStudentAndLevelWise: `${baseURL}/certificateReportStudentAndLevelWise`,
  certificateStatusReport: `${baseURL}/certificateStatusReport`,
  competitionParticipantStudentRegional: `${baseURL}/competitionParticipantStudentRegional`,
  prodigyMetricDataReportRegional: `${baseURL}/competitionParticipantStudentRegional`,
  prodigyMetricDataReportNational: `${baseURL}/`,
  nationalKolorChamp: `${baseURL}/nationalKolorChamp`,
  regionalKolorChamp: `${baseURL}/regionalKolorChamp`,
  studentLevelDurationReportStudentWise: `${baseURL}/studentLevelDurationReportStudentWise`,
  studentLevelDurationReportFranchiseeWise: `${baseURL}/studentLevelDurationReportLCLWise`,
  stockSoldAndStockOrderedForHigherLevelChannel: `${baseURL}/stockSoldAndStockOrderedForHigherLevelChannel`,
  studentInformationReport: `${baseURL}/studentInformationReport`,
  monthwiseRoyaltyReport: `${baseURL}/monthwiseRoyaltyReport`,
  netStudentsVsReceiptsHo: `${baseURL}/netStudentsVsReceiptsHo`,
  studentwiseRoyaltyFeeReport: `${baseURL}/studentWiseRoyaltyFeesReportInvoice`,
  myBusinessTrackerReport: `${baseURL}/myBusinessTrackerReport`,
  BusinessTrackerPlusandNonPlusReport: `${baseURL}/businessTrackerPlusAndNonPlus`,
  BusinessTrackerPlus: `${baseURL}/businessTrackerPlus`,
  paymentReport: `${baseURL}/paymentReport`,
  gstReport: `${baseURL}/gstTaxReturnReport`,
  studentBirthdayReport: `${baseURL}/studentBirthdayReport`,
  studentReceiptReport: `${baseURL}/studentwiseReceiptReport`,
  zohoCRMLeadReport: `${baseURL}/zohoCRMLeadReport`,
};
